import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import * as telemetry from '@/lib/telemetry';

interface TrackedLinkProps {
  label: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TrackedLink',
  props: {
    label: {}
  },
  setup(__props: any) {

const props = __props;



const telemetryClick = () => {
  telemetry.trackClick(props.label);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", { onClick: telemetryClick }, [
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})